import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locations: [],
  courts: [],
  locationsCourt: [],
};

export const allPreLoadedApis = createSlice({
  name: "all preloaded api",
  initialState,
  reducers: {
    setAllPreloadedApi: (state, action) => {
      state.locations = action?.payload?.locations;
      state.courts = action?.payload?.courts;
      state.blockedSlots = action?.payload?.blockedSlots;
    },
    // setLocationCorrespondCourts: (state, action) => {
    //   if(state?.locations?.length >0)
    //   state.locationsCourt = state?.locations?.courts?.map(data=>({label:data?.courtId,value:""}))
    // },
  },
});

export const { setAllPreloadedApi } = allPreLoadedApis.actions;
export default allPreLoadedApis.reducer;
